// 客户端统一请求入口: 按机构拼接服务前缀, 自动带 Tenant-ID 与 Authorization
// 路径只写服务内相对部分, 如 apiFetch('/user/login')
import { Cookies } from 'react-cookie'
import { getTenantId } from '@/hooks/getBaseUrl'
import { getServiceForTenant, getServicePath, type ApiService } from '@/hooks/resolveTenantId'

export interface ApiFetchOptions extends RequestInit {
  /** 覆盖机构 id, 默认按当前域名解析 */
  tenantId?: string
  /** 覆盖鉴权头, 默认从 token cookie 读取 */
  authorization?: string
  /** 强制指定服务, 默认按机构决定 (C 走 portal, 其余走 tenant) */
  service?: ApiService
}

/** 从 token cookie 拼出 Authorization 值 (tokenHead + token), 未登录返回空串 */
export function getAuthorizationFromCookie(): string {
  const token = new Cookies().get('token')
  if (!token?.token) return ''
  return `${token.tokenHead || ''}${token.token}`
}

export function buildApiHeaders(options: Pick<ApiFetchOptions, 'tenantId' | 'authorization' | 'headers'> = {}): Headers {
  const headers = new Headers(options.headers)
  headers.set('Tenant-ID', options.tenantId || getTenantId())
  const authorization = options.authorization ?? getAuthorizationFromCookie()
  if (authorization) headers.set('Authorization', authorization)
  return headers
}

export function buildApiUrl(path: string, options: Pick<ApiFetchOptions, 'tenantId' | 'service'> = {}): string {
  const tenantId = options.tenantId || getTenantId()
  const service = options.service || getServiceForTenant(tenantId)
  return `${getServicePath(service)}${path}`
}

export async function apiFetch(path: string, options: ApiFetchOptions = {}): Promise<Response> {
  const { tenantId, authorization, service, headers, ...init } = options
  return fetch(buildApiUrl(path, { tenantId, service }), {
    ...init,
    headers: buildApiHeaders({ tenantId, authorization, headers }),
  })
}
